
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { Client, IJobItemActivityModel, ActivityInvoiceType as JobItemActivityModelInvoiceType } from '@/services/api.service';
  import toDateFormatter from '@/filters/todate.formatter';
  import toHoursMinutesFormatter from '@/filters/tohoursminutes.formatter';
  import { ActivityInvoiceType } from '@/common/enumerations';

  @Component({
    props: {
      jobNumber: String,
      activities: {
        type: Array as () => IJobItemActivityModel[],
        required: true
      }
    },
    filters: {
      toDate: toDateFormatter,
      toHoursMinutes: toHoursMinutesFormatter
    }
  })
  export default class JobItemActivityList extends Vue {
    private deleteJobItemActivity(activity: IJobItemActivityModel) {
      this.$emit('on-delete-jobitemactivity', activity);
    }

    private isNormalInvoiceType(activity: IJobItemActivityModel): boolean {
      if (activity) {
        if (activity.invoiceType === JobItemActivityModelInvoiceType._0) {
          return activity.isInvoiced || false;
        }
      }
      return false;
    }
    private isNoInvoiceType(activity: IJobItemActivityModel): boolean {
      if (activity) {
        if (activity.invoiceType === JobItemActivityModelInvoiceType._1) {
          return true;
        }
      }
      return false;
    }
    private isExternalInvoiceType(activity: IJobItemActivityModel): boolean {
      if (activity) {
        if (activity.invoiceType === JobItemActivityModelInvoiceType._2) {
          return true;
        }
      }
      return false;
    }
  }
